import { BookmarkCheck, Calendar } from "lucide-react";
import { useState } from "react";
import AllAutoRequestsDrawer from "./AllRequestsDrawer";

export default function MontlyWrapper({ monthlyRequests, month }: any) {
  const [detailsModal, setDetailsModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);
  return (
    <div>
      {monthlyRequests?.data?.map((item: any) => (
        <div
          key={item?._id}
          className={`flex justify-between border p-2 m-1 cursor-pointer hover:bg-blue-100 hover:border-blue-200 transition-all duration-300 `}
          onClick={() => {
            setDetailsModal(true);
            setSelected(item);
          }}
        >
          <div className="flex items-center gap-x-2">
            <Calendar size={16} className="text-blue-400" />

            <div className="text-gray-700">{item?.longMonth}</div>
          </div>
          <div
            className={` flex items-center gap-x-2 ${
              month === item?.monthNumber ? "text-blue-500" : "text-gray-700"
            }`}
          >
            {month === item?.monthNumber ? (
              <BookmarkCheck size={12} className="text-blue-400" />
            ) : (
              ""
            )}
            {item?.count}
          </div>
        </div>
      ))}
      {detailsModal && (
        <AllAutoRequestsDrawer
          title="Requests by Month"
          isVisible={detailsModal}
          setVisible={setDetailsModal}
          selected={selected}
          startDate={selected?.startDate}
          endDate={selected?.endDate}
        />
      )}
    </div>
  );
}
